module.exports = __webpack_public_path__ + "img/icon-avocado-bread.0466659d.svg";